
import React from 'react';

const PainPointsSection: React.FC = () => {
  const painPoints = [
    {
      icon: "ri-alarm-warning-line",
      title: "Dangerous Ladder Climbing",
      description: "Stop risking falls and injuries cleaning gutters multiple times per year",
      image: "https://public.readdy.ai/ai/img_res/1fd85268f1395082dc368115d7ca12bb.jpg"
    },
    {
      icon: "ri-water-flash-line",
      title: "Expensive Water Damage",
      description: "Clogged gutters cause foundation damage, basement flooding, and costly repairs",
      image: "https://readdy.ai/api/search-image?query=Expensive%20water%20damage%20to%20home%20foundation%20and%20basement%20from%20clogged%20gutters%2C%20flooded%20basement%2C%20water%20stains%20on%20walls%2C%20foundation%20cracks%2C%20costly%20home%20repairs%2C%20insurance%20claim%20documentation&width=400&height=300&seq=pain-002&orientation=landscape"
    },
    {
      icon: "ri-time-line",
      title: "Constant Maintenance",
      description: "Endless cycle of cleaning, repairs, and gutter maintenance throughout the year",
      image: "https://readdy.ai/api/search-image?query=Frustrated%20homeowner%20constantly%20cleaning%20gutters%20filled%20with%20leaves%20and%20debris%2C%20repetitive%20maintenance%20work%2C%20seasonal%20gutter%20cleaning%20chore%2C%20time%20consuming%20home%20maintenance%2C%20exhausted%20person%20on%20ladder&width=400&height=300&seq=pain-003&orientation=landscape"
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Professional Cleaning Costs",
      description: "Paying hundreds annually for professional gutter cleaning services",
      image: "https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/0708ac489d482d163d55bc8195d46774.jpeg"
    }
  ];

  return (
    <section className="py-20 bg-red-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            The Hidden Costs of Clogged Gutters
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Don't let gutter problems drain your wallet and endanger your family. 
            See what you're really paying for without proper gutter protection.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {painPoints.map((point, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="relative h-48">
                <img 
                  src={point.image}
                  alt={point.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-red-600/20"></div>
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mr-4">
                    <i className={`${point.icon} text-white text-xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800">{point.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed">{point.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12 bg-white rounded-lg p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-gray-800 mb-4">
            Stop the Clogs, Climbing and Costs - Protect Your Home Today
          </h3>
          <p className="text-gray-600 mb-6">
            Most homes can be completely protected for just $300-$400. 
            That's less than 2 years of professional cleaning costs!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <div className="bg-orange-500 text-white px-6 py-3 rounded-lg font-bold">
              One-time cost: $300-$400
            </div>
            <div className="bg-gray-800 text-white px-6 py-3 rounded-lg font-bold">
              vs. $200+ annually for cleaning
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PainPointsSection;
